import React from 'react';

import { Color } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import { IconPosition } from '../../molecules/team/team';
import IconChronometer from '../icons/icon-chronometer';
import Text from '../text/text';

import './best-lap.scss';

export interface IBestLap extends IComponent {
  colorSvg?: Color;
  positionSvg?: IconPosition;
}

const classNames = (positionSvg: IconPosition | undefined) =>
  makeClassNames({
    bestLap: ['best-lap', positionSvg && `best-lap--svg-${positionSvg}`],
    bestLapChronometer: 'best-lap__chronometer',
  });

const BestLap = ({
  children,
  /* istanbul ignore next: default value */ fontSize = '14',
  /* istanbul ignore next: default value */ fontWeight = '500',
  /* istanbul ignore next: default value */ color = 'blue',
  /* istanbul ignore next: default value */ size = 'xxsmall',
  colorSvg,
  /* istanbul ignore next: default value */ positionSvg = 'left',
}: IBestLap) => {
  const cn = classNames(positionSvg);
  return (
    <div className={cn.bestLap}>
      <div className={cn.bestLapChronometer}>
        <IconChronometer size={size} color={colorSvg || color} />
      </div>
      <Text fontSize={fontSize} fontWeight={fontWeight} color={color}>
        {children}
      </Text>
    </div>
  );
};

export default BestLap;
